<template>
  <div class="container py-0">
    <v-row class="row">
      <v-col cols="auto" class="d-flex align-center">
        <router-link
          class="d-flex align-center white--text title-printers"
          :to="{
            name: this.$route.params.code ? 'customer.printers' : 'home',
            params: { code: this.$route.params.code }
          }"
        >
          <h1 class="logo-printers"><strong>Stavy tiskáren</strong></h1>
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TheHeader',
};
</script>

<style lang="scss">
@import '../scss/utilities/px-to-rem';

.logo-printers {
  font-weight: normal;
  @include rem(font-size, 26px);
  line-height: 1.25;
}

.title-printers {
  text-decoration: none;
}

.logo-printers {
  color: #21262a;
}

.logo-sidetitle {
  position: relative;
  color: #fff;
  @include rem(font-size, 16px);
  text-transform: uppercase;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 40px;
    width: 1px;
    background: rgba(255, 255, 255, 0.35);
  }
}
</style>
